import React from "react";
import HelpModal from "common/HelpModal.jsx";

const LinkStateHelpModal = () => (
  <HelpModal
    title="NETWORK INTERFACES"
    content={() => (
      <>
        <p>Network interfaces details at the time of loading the page.</p>
        <ul>
          <li>
            <b>NAME</b>: Interface name.
          </li>
          <li>
            <b>TYPE</b>: Interface port type. Physical ports are of type
            "ethernet".
          </li>
          <li>
            <b>MAC</b>: Ethernet MAC address.
          </li>
          <li>
            <b>UP</b>: <span className="col-green">Checked</span> if network
            interface is up. <span className="col-red">Unchecked</span> if down
            or not configured.
          </li>
          <li>
            <b>LINK</b>: <span className="col-green">Checked</span> if link
            detected. <span className="col-red">Unchecked</span> if undetected
            (e.g. the cable is not connected, the peer port is down, etc).
          </li>
          <li>
            <b>MGT</b>: Indicates interface used for Management.
          </li>
        </ul>
        <p>
          Click on the <i className="material-icons valign-icon">refresh</i>{" "}
          icon to refresh interface information.
        </p>
        <p>
          Click on the <i className="material-icons valign-icon">search</i> icon
          to set up a tcpdump packet capture.
        </p>
        <p>
          Click on the <i className="material-icons col-red">arrow_downward</i>
          icon to disable an interface. Click on the{" "}
          <i className="material-icons col-green">arrow_upward</i> icon to
          enable a previously disabled interface.
        </p>
      </>
    )}
  />
);

export default LinkStateHelpModal;
